import { FS } from '@dadohr/shared/versions';
import { compact } from 'lodash';

import { store, useMappedLoadingValue } from '../firebase';
import {
  CollectionListener,
  createCollectionListenerStore,
  useCollectionListener
} from '../firecache/collectionListener';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../firecache/documentListener';
import {
  toAdminUserDoc,
  toAdminUserInvitationDoc,
  toAdminUsersPerOrgDoc
} from './documents';

export const adminUsersCollection = () => store().collection(FS.adminUsers);
export const adminUserInvitationsCollection = () =>
  store().collection(FS.adminUserInvitations);

export const adminUserRef = (id: string) => adminUsersCollection().doc(id);

export const getAdminUser = (id: string) => {
  return adminUserRef(id)
    .get()
    .then((s) => {
      if (!s.exists) {
        return null;
      }
      return toAdminUserDoc(s);
    });
};

export const adminUsersPerOrgStore = createDocumentListenerGetter(
  (orgId) => store().collection(FS.adminUsersPerOrg).doc(orgId),
  toAdminUsersPerOrgDoc
);

export const useAdminUsersInOrg = (orgId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(adminUsersPerOrgStore(orgId)),
    (d) => (d ? compact(Object.values(d?.data.admins)) : [])
  );
};

const adminUsersInvitationsByOrg = createCollectionListenerStore(
  (orgId) =>
    new CollectionListener(
      adminUserInvitationsCollection().where('orgId', '==', orgId),
      toAdminUserInvitationDoc
    )
);

export const useAdminUserInvitationsInOrg = (orgId: string) => {
  return useCollectionListener(adminUsersInvitationsByOrg(orgId));
};

export const useAdminUserById = (orgId: string, adminId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(adminUsersPerOrgStore(orgId)),
    (d) => d?.data.admins[adminId] || null
  );
};
